module.exports = __webpack_public_path__ + "img/customer-service.bb563a60.png";